import * as React from "react";
import {observer} from "mobx-react";
import type {Field} from "../../../../../data/models/field/Field";
import type {XyiconFeature} from "../../../../../generated/api/base";
import {FieldForm} from "./FieldForm";

interface IFieldDetailsContentProps {
	readonly selected: Field[];
	readonly typesFeature: XyiconFeature;
}

@observer
export class FieldDetailsContent extends React.Component<IFieldDetailsContentProps> {
	public override render() {
		const {selected, typesFeature} = this.props;
		const field = selected[0];

		return (
			<>
				{selected.length === 0 && <div className="noData">Please select a field.</div>}
				{selected.length === 1 && (
					<FieldForm
						key={`${field?.refId} ${field?.name}`}
						field={field}
						typesFeature={typesFeature}
					/>
				)}
			</>
		);
	}
}
